/**
 * Retailer catalog for the landing page — grouped by region for the wall.
 * Single source of truth: matches the manifest host_permissions in
 * packages/extension/manifest.json and SUPPORTED_RETAILERS in
 * packages/shared/types.ts. Changes here should be mirrored there.
 */

export interface Retailer {
  /** Hostname (matches DB retailer_domain) */
  host: string;
  /** Display name */
  name: string;
}

export const retailers = {
  international: [
    { host: 'farfetch.com', name: 'Farfetch' },
    { host: 'net-a-porter.com', name: 'Net-a-Porter' },
    { host: 'mytheresa.com', name: 'Mytheresa' },
    { host: 'ssense.com', name: 'SSENSE' },
    { host: '24s.com', name: '24S' },
    { host: 'modaoperandi.com', name: 'Moda Operandi' },
    { host: 'matchesfashion.com', name: 'Matches' },
    { host: 'harrods.com', name: 'Harrods' },
    { host: 'saks.com', name: 'Saks' },
  ],
  resale: [
    { host: 'vestiairecollective.com', name: 'Vestiaire Collective' },
    { host: 'therealreal.com', name: 'The RealReal' },
    { host: 'rebag.com', name: 'Rebag' },
    { host: 'fashionphile.com', name: 'Fashionphile' },
    { host: 'collectorsquare.com', name: 'Collector Square' },
    { host: 'collectorscage.com', name: "Collector's Cage" },
    { host: 'thebrandcollector.com', name: 'The Brand Collector' },
    { host: 'yoogiscloset.com', name: "Yoogi's Closet" },
    { host: '1stdibs.com', name: '1stDibs' },
  ],
  gcc: [
    { host: 'theluxurycloset.com', name: 'The Luxury Closet' },
    { host: 'ounass.ae', name: 'Ounass' },
    { host: 'bloomingdales.ae', name: "Bloomingdale's AE" },
    { host: 'coach.ae', name: 'Coach AE' },
    { host: 'garderobe.ae', name: 'Garderobe' },
    { host: 'loveluxury.ae', name: 'LoveLuxury' },
    { host: 'luxurypromise.com', name: 'Luxury Promise' },
    { host: 'gemaee.com', name: 'Gema' },
    { host: 'taggy.ae', name: 'Taggy' },
    { host: 'lasuite.ae', name: 'La Suite' },
    { host: 'bazaara.com', name: 'Bazaara' },
    { host: 'shopretold.com', name: 'Retold' },
    { host: 'luxbrandsuae.com', name: 'LuxBrands UAE' },
    { host: 're-lovedluxury.com', name: 'Re-Loved Luxury' },
    { host: 'alluuae.com', name: 'Allu UAE' },
    { host: 'dwisi.ae', name: 'Dwisi' },
    { host: 'reemscloset.com', name: "Reem's Closet" },
    { host: 'bestkeptshared.com', name: 'BestKept' },
    { host: 'theclosetonlineshop.com', name: 'The Closet' },
    { host: 'amusedco.com', name: 'Amused Co' },
    { host: 'shaikhascloset.com', name: "Shaikha's" },
    { host: 'blingblingsabaya.com', name: 'BlingBling' },
    { host: 'libascollective.com', name: 'Libas Collective' },
    { host: 'bagsloverdubai.com', name: 'Bags Lover Dubai' },
  ],
} as const;

export const retailerCount =
  retailers.international.length +
  retailers.resale.length +
  retailers.gcc.length;
